export class Home {
  constructor(http) {
    this.http = http;
  }

  fetchHome(startDate, endDate) {
    if (startDate && endDate) {
      startDate = startDate.valueOf();
      endDate = endDate.valueOf();
    }

    return this.http
      .get(`home`, { params: { startDate, endDate } })
      .then(response => response.data);
  }

}
